import React, { createContext, useContext, useMemo } from "react";
import { CategoryContext } from "@root/context/category";
import { get } from "lodash";

export const DynamicContentContext = createContext();

export const DynamicContentProvider = ({ children }) => {
    const { currentCategory } = useContext(CategoryContext);

    // rewrite getDynamicContent function with useMemo
    const getDynamicContent = useMemo(() => (path, _default) => {
        const data = { category: currentCategory };

        // Get data by path from data object, use lodash get method
        return get(data, path, _default);
    }, [currentCategory]);

    const value = useMemo(() => ({ getDynamicContent }), [getDynamicContent]);

    return (
        <DynamicContentContext.Provider value={value}>
            {children}
        </DynamicContentContext.Provider>
    );
};
